export default __webpack_public_path__ + "static/media/ImminentCatharsis-MasteredFinal.88dc9247.mp3";